module.exports = __webpack_public_path__ + "static/img/coupon-bg.9782ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/service/coupon-bg.png
// module id = 9tnE
// module chunks = 86